// extracted by mini-css-extract-plugin
module.exports = {"root":"_1mRC","section":"_3lHx","img":"_1hoV","section1":"hGEh","left":"_381x","right":"_2geN","section2":"_23Cj","group":"w2ax"};